<div class="bar-container">
    <div class="flex flex-row">
        <div class="scrollmenu sectors-links">
            <div class="under-bar">
                <owl-carousel-o #owlCar (initialized)="setPage(owlCar)" appOwlPreventClick
                    *ngIf="categories && categories.length > 0" [options]="carouselOptions">
                    <ng-template [id]="sector.seo?.slug" carouselSlide *ngFor="let category of categories"
                        [width]="category.width || category.chipWidth || 150">
                        <a appclick [routerLink]="['/category', category?.seo?.slug]">
                            <div class="category-label block-subcategories__item cursor-pointers"
                                [class.active]="selectedSector == category?.seo?.slug"
                                [style.background-color]="selectedSector == category?.seo?.slug ? category?.colors?.activeBackground : category?.colors?.background"
                                [style.color]="selectedSector == category?.seo?.slug ? category.colors?.activeForeground : category.colors?.foreground"
                                (click)="selectionChange(category)">
                                {{translateHelper.localize(category.name)}}
                            </div>
                        </a>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</div>